<template>
    <div>
      <!-- TEXT TO 17 STEPS ACADEMY-->
      <div v-if="cardId <= 17">
        <div class="mb-3">You can let people know what to expect when they use Dropsmart through a simple review. This is really easy to do and it will not take much time but it does have a strong impact.</div>
        <div class="mb-3">We'd greatly appreciate if you could share the best thing you like about Dropsmart and how you benefit from it in the comment section on the right.</div>
        <div>Thank you.</div>
      </div>

      <!-- TEXT TO Dropsmart's secrets -->
      <div v-if="cardId === 18">
        <div>2018 was an incredible year for Dropsmart (at that time, still Dropsmith). Dropsmart was recognized as a revolutionary tool to support the aromatherapy community so Melani (our founder), was invited to present the project at numerous conferences and events worldwide.&nbsp;</div>
        <div>One of them was THE BEYOND THE ESSENTIAL OIL RECIPE SUMMIT and they are so kind to share this exclusive video with us.</div>
      </div>

      <!-- TEXT TO PRO TIPS CATEGORY VIDEOS ON ACADEMY-->
      <div v-if="cardId > 18">
        <div class="mb-3">We want to make sure that Dropsmart is the best that is can be and constant feedback does help. Would you be willing to leave a comment so others can see what we do?</div>
        <div class="mb-3">When you write your review all we ask for you to explain is where you were before you started using Dropsmart, what you went through looking for a solution and how we helped you out.</div>
        <div>Thank you for your contribution.</div>
      </div>

    </div>
</template>

<script>
export default {
  name: "AcademyTextLeftModal",
  mounted() {
    this.cardId = parseInt(this.$route.query.step)
  },
  data() {
    return {
        cardId: 0,
    }
  }
}
</script>

<style scoped lang="scss">
div.ql-block {
  margin-bottom: 1rem;
}
a.ql-link {
  display: inline-block;
  color: black;
  &:hover {
    color: #999999;
  }
}
</style>
